import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaEnvelope, FaPhone, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">Aesthetic <span>AI</span> Receptionist</div>
            <p className="footer-copyright">© 2024 VitalAI, Inc. All rights reserved.</p>
          </div>
            <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-contact">
            <div className="contact-item">
              <a href="mailto:contact@aestheticsai.us">
                <FaEnvelope className="contact-icon" />
                <span>contact@aestheticsai.us</span>
              </a>
            </div>
            <div className="contact-item">
              <a href="tel:8565881302">
                <FaPhone className="contact-icon" />
                <span>856-588-1302</span>
              </a>
            </div>
          </div>
          
          <div className="social-item">
            <a href="https://www.linkedin.com/company/aesthetic-ai-receptionist/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="social-icon linkedin-icon" />
            </a>
            <a href="https://www.instagram.com/aesthetic_ai_receptionist/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="social-icon instagram-icon" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
